import type { CustomWidgetProps } from "../../patterns/command-shell/types";

/**
 * Whether the command still waits for its item. Add catalogue item… picks the item in the shell's own fields, and its
 * dry run asks for it (`item_id` required) until one is chosen; the item's specification and the line's delivery are
 * drawn only once it is. A command whose item is its target (Add to draft quote…) never asks, so this is false for it.
 */
export function isItemToChoose(props: Pick<CustomWidgetProps, "dryRun">) {
  return props.dryRun?.errors.some((e) => e.field === "item_id") ?? false;
}
